module.exports = __webpack_public_path__ + "72e52736d167c32a15c59f6f03ece190.png";